import { render } from "./ListSquad.vue?vue&type=template&id=cf0f3a54&scoped=true"
import script from "./ListSquad.vue?vue&type=script&lang=js"
export * from "./ListSquad.vue?vue&type=script&lang=js"

import "./ListSquad.vue?vue&type=style&index=0&id=cf0f3a54&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0f3a54"]])

export default __exports__